// @ts-nocheck
/* eslint-disable */
import * as registry from '../../registry.js'
/**
* @param {{  }} i
*/
export const attendingPrompt_addedToWaitlist = (i) => `Aber du wurdest auf die Warteliste gesetzt und wirst kontaktiert sobald ein Platz frei wird.`